var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfo = function SvgInfo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#898098",
    d: "M9.5 5h2v2h-2V5Zm0 4h2v6h-2V9Zm1-9C4.98 0 .5 4.48.5 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNSA1SDExLjVWN0g5LjVWNVpNOS41IDlIMTEuNVYxNUg5LjVWOVpNMTAuNSAwQzQuOTggMCAwLjUgNC40OCAwLjUgMTBDMC41IDE1LjUyIDQuOTggMjAgMTAuNSAyMEMxNi4wMiAyMCAyMC41IDE1LjUyIDIwLjUgMTBDMjAuNSA0LjQ4IDE2LjAyIDAgMTAuNSAwWk0xMC41IDE4QzYuMDkgMTggMi41IDE0LjQxIDIuNSAxMEMyLjUgNS41OSA2LjA5IDIgMTAuNSAyQzE0LjkxIDIgMTguNSA1LjU5IDE4LjUgMTBDMTguNSAxNC40MSAxNC45MSAxOCAxMC41IDE4WiIgZmlsbD0iIzg5ODA5OCIvPgo8L3N2Zz4K";